import { render, staticRenderFns } from "./AddUsersForm.vue?vue&type=template&id=940cb596&scoped=true&"
import script from "./AddUsersForm.vue?vue&type=script&lang=js&"
export * from "./AddUsersForm.vue?vue&type=script&lang=js&"
import style0 from "./AddUsersForm.vue?vue&type=style&index=0&id=940cb596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940cb596",
  null
  
)

export default component.exports